
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { IItem, ILiteItem } from "@tylertech/tyler-api-types";

/**
 * ItemService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class ItemService {
    private readonly $apiService = inject(ApiService);
    
    GetItem(pItemId: string): Promise<IItem> {
        return this.$apiService.sendAuth("IItemService/GetItem", pItemId);
    }
    GetNextItemNumber(): Promise<string> {
        return this.$apiService.sendAuth("IItemService/GetNextItemNumber");
    }
    ItemsLite(): Promise<ILiteItem[]> {
        return this.$apiService.sendAuth("IItemService/ItemsLite");
    }
    SaveItem(pItem: IItem): Promise<IItem> {
        return this.$apiService.sendAuth("IItemService/SaveItem", pItem);
    }
}
